export default __webpack_public_path__ + "static/media/logo.e1f91c5c.png";